import _typeof from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import store from '../store';
import { MessageBox } from 'element-ui';
import Vue from 'vue';
var lang = Vue.prototype;
export var oneDayLong = 24 * 60 * 60 * 1000;
/* eslint-disable */
// 绑在Vue原型上面
export var util = {
  ridUrlParam: function ridUrlParam(url, aParam) {
    aParam.forEach(function (item) {
      var fromindex = url.indexOf("".concat(item, "=")); //必须加=号，避免参数值中包含item字符串
      if (fromindex !== -1) {
        // 通过url特殊符号，计算出=号后面的的字符数，用于生成replace正则
        var startIndex = url.indexOf('=', fromindex);
        var endIndex = url.indexOf('&', fromindex);
        var hashIndex = url.indexOf('#', fromindex);
        var reg;
        if (endIndex !== -1) {
          // 后面还有search参数的情况
          var num = endIndex - startIndex;
          reg = new RegExp("".concat(item, "=.{").concat(num, "}"));
          url = url.replace(reg, '');
        } else if (hashIndex !== -1) {
          // 有hash参数的情况
          var _num = hashIndex - startIndex - 1;
          reg = new RegExp("&?".concat(item, "=.{").concat(_num, "}"));
          url = url.replace(reg, '');
        } else {
          // search参数在最后或只有一个参数的情况
          reg = new RegExp("&?".concat(item, "=.+"));
          url = url.replace(reg, '');
        }
      }
    });
    var noSearchParam = url.indexOf('=');
    if (noSearchParam === -1) {
      url = url.replace(/\?/, ''); // 如果已经没有参数，删除？号
    }

    return url;
  },
  /**
   *
   * @example parseTime(new Date(), '{h}:{i}')
   * // @returns 21:20
   * @param { Date } time 时间对象
   * @param {*} cFormat 目标格式
   * @returns { string } 目标格式时间
   */
  parseTime: function parseTime(time, cFormat) {
    if (arguments.length === 0) {
      return null;
    }
    var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
    var date;
    if (_typeof(time) === 'object') {
      date = time;
    } else {
      if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
        time = parseInt(time);
      }
      if (typeof time === 'number' && time.toString().length === 10) {
        time = time * 1000;
      }
      date = new Date(time);
    }
    var formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
    };
    var time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, function (result, key) {
      var value = formatObj[key];
      // Note: getDay() returns 0 on Sunday
      if (key === 'a') {
        return ['日', '一', '二', '三', '四', '五', '六'][value];
      }
      if (result.length > 0 && value < 10) {
        value = '0' + value;
      }
      return value || 0;
    });
    return time_str;
  },
  /**
   *
   * @param {*} value 输入的值
   * @param {*} type  类型： 1 金额 2 金额 3 数字类型
   * @returns { string } 格式
   */
  // 用户输入格式化
  valueFormat: function valueFormat(value, type) {
    if (type === 1) {
      // 金额类型
      return String(value).replace(/[^0-9\.]+/g, '').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\d+)\.(\d\d).*$/, '$1.$2');
    } else if (type === 2) {
      // 金额类型
      var str = String(value).replace(/[^0-9\.]+/g, '').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
      if (str && str !== '.') {
        return Number(str).toFixed(2);
      } else {
        return '';
      }
    } else if (type === 3) {
      // 数字类型
      return String(value).replace(/\D+/g, '');
    }
  },
  messageBox: function messageBox(message, type, confirmFunc, cancelFunc) {
    MessageBox({
      type: type,
      title: lang.$t('229'),
      message: message,
      confirmButtonText: lang.$t('131'),
      showCancelButton: true,
      cancelButtonText: lang.$t('66'),
      closeOnClickModal: false
    }).then(function () {
      confirmFunc();
    }).catch(function (err) {
      cancelFunc();
    });
  },
  permissionCheck: function permissionCheck(key) {
    return store.getters.permissionList.includes(key);
  },
  getLocationQueryParam: function getLocationQueryParam(key) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'hash';
    var value = '';
    var reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)');
    if (type === 'search') {
      value = window.location.search.replace('&amp;', '&').substring(1).match(reg);
    } else if (type === 'hash') {
      var hash = window.location.hash;
      var index = hash.indexOf('?');
      if (index === -1) {
        value = null;
      } else {
        value = hash.replace('&amp;', '&').substring(index + 1).match(reg);
      }
    }
    return value === null ? null : unescape(value[2]);
  },
  /**
   * @param {*} func 执行的函数
   * @param {*} gap  时间
   * @returns { function } 最终执行的函数
   */
  debounce: function debounce(func) {
    var gap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var timer;
    return function () {
      var _arguments = arguments,
        _this = this;
      timer && clearTimeout(timer);
      timer = setTimeout(function () {
        func.apply(_this, _arguments);
      }, gap);
    };
  },
  /**
   * @param {*} func 执行的函数
   * @param {*} wait 等待时间
   * @returns { function } 最终执行的函数
   */
  throttle: function throttle(func, wait) {
    var previous = 0;
    return function () {
      var now = Date.now();
      var context = this;
      var args = arguments;
      if (now - previous > wait) {
        func.apply(context, args);
        previous = now;
      }
    };
  },
  // 图片格式是否满足
  isPicture: function isPicture(key) {
    return ['jpg', 'jpeg', 'png'].includes(key);
  },
  fmtDate: function fmtDate(fmt) {
    var tags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var t = tags ? new Date(tags) : new Date();
    var o = {
      'M+': t.getMonth() + 1,
      // 月份
      'd+': t.getDate(),
      // 日
      'h+': t.getHours(),
      // 小时
      'm+': t.getMinutes(),
      // 分
      's+': t.getSeconds(),
      // 秒
      'q+': Math.floor((t.getMonth() + 3) / 3),
      // 季度
      S: t.getMilliseconds() // 毫秒
    };

    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (t.getFullYear() + '').substr(4 - RegExp.$1.length));
    for (var k in o) if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    return fmt;
  },
  // 获取 相对于今天 的时间戳
  getTime: function getTime() {
    var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
    return new Date().getTime() + n * oneDayLong;
  },
  arrUnique: function arrUnique(arr, name) {
    var hash = {};
    return arr.reduce(function (item, next) {
      hash[next[name]] ? '' : hash[next[name]] = true && item.push(next);
      return item;
    }, []);
  }
};

// 获取位置
export var getPosition = function getPosition() {
  var position = false;
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(function (position) {
      var lat = position.coords.latitude;
      var lng = position.coords.longitude;
      position = {
        lat: lat,
        lng: lng
      };
    });
  }
  return position;
};

// 名称取名规则
export var createName = function createName(name) {
  // 英文取首字母大写
  // 是否包含英文已外的字符 包含则取后俩位
  var isNotEn = name.replace(' ', '').match(/\W/g);
  if (isNotEn && isNotEn.length) return name.substr(-2, 2);
  // 如果只是英文 则返回如下：
  // 首字母
  var first = name.charAt(0);
  var splitName = name.split(' ');
  // 是否有空格区分 有则取第一组和最后一组的首字母大写
  if (splitName && splitName.length) {
    if (splitName.length > 1) {
      var str = splitName.slice(-1);
      return "".concat(first).concat(str[0].charAt(0)).toUpperCase();
    }
  }
  return first;
};

// 判断元素里是否存在子元素
export var isHas = function isHas(str, el) {
  if (!el) return false;
  if (!el.children || !el.children.length) return false;
  var list = Array.from(el.children);
  var node = list.filter(function (node) {
    var classes = node.getAttribute('class');
    if (classes && classes.indexOf && classes.indexOf(str) >= 0) return node;
  });
  return node && node.length && node[0];
};

// 生成色值数组
export var createColors = function createColors(num) {
  // 色值位数补全 标准6位 例；#FFFFFF
  var completionColor = function completionColor(str) {
    return str.length < 2 ? "0".concat(str) : str;
  };
  // @param { number } number 生成个数
  var createColor = function createColor(number) {
    var create = function create() {
      return Array.from({
        length: 3
      }).map(function () {
        return Math.floor(Math.random() * 255);
      });
    };
    return '#' + create().reduce(function (acc, cur, index) {
      var last = index === 1 ? completionColor(acc.toString(16)) : acc;
      return last + completionColor(cur.toString(16));
    });
  };
  return Array.from({
    length: Number(num)
  }).map(function () {
    return createColor();
  });
};

// 获取头像
export var getAvatar = function getAvatar(sex) {
  return {
    0: require('@/assets/img/avatar-default.png'),
    1: require('@/assets/img/avatar-man.png'),
    2: require('@/assets/img/avatar-woman.png')
  }[sex];
};

/**
 *  点击元素之外执行的函数 常用于点击弹窗之外隐藏弹窗
 *  @param { classes } class 组
 *  @param { callbackFn } 回掉
 * */
export var outClick = function outClick(classes, callbackFn) {
  var fn = function fn(_ref) {
    var path = _ref.path;
    var state = path.some(function (item) {
      return classes.some(function (el) {
        var _item$className;
        return item === null || item === void 0 || (_item$className = item.className) === null || _item$className === void 0 ? void 0 : _item$className.includes(el);
      });
    });
    callbackFn(!state);
  };
  window.addEventListener('click', fn);
  return fn;
};
outClick.prototype.remove = function (fn) {
  window.removeEventListener('click', fn);
};